import { render } from "./TheProfessionalInterConsultationsList.vue?vue&type=template&id=1ee37590&scoped=true&ts=true"
import script from "./TheProfessionalInterConsultationsList.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalInterConsultationsList.vue?vue&type=script&lang=ts"

import "./TheProfessionalInterConsultationsList.vue?vue&type=style&index=0&id=1ee37590&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee37590"]])

export default __exports__